import React from 'react';
import { TermsLogin } from '../TermsLogin';
import Url from '../../../Helpers/Url';
import { getCallbackResetPassword } from '../../../Helpers/Auth0StorageManager';
import { useHistory } from 'react-router';


export const ConfirmarMail = ({ user, comeBack }) => {
    const callback = getCallbackResetPassword();
    const history = useHistory();
    const getTipoDeIngreso = () => {
        switch (user.tipoDeIngreso) {
            case 'googleProfile':
                return 'Google';
            case 'facebookProfile':
                return 'Facebook';
            case 'appleProfile':
                return 'Apple ID';
            default:
                return 'Email y contraseña';
        }
    };

    const esPerfilSocial = [
        'googleProfile',
        'facebookProfile',
        'appleProfile',
    ].includes(user.tipoDeIngreso);

    return (
        <div className="container-found-mail">
            <header className="found-description">
                <h1 className="found-description-title">
                    Encontramos una cuenta con este número de DNI {user.dni}
                </h1>
            </header>

            <section className="found-mail-text">
                <div>El email con el que te registraste es:</div>
                <div>
                    <strong>{user.email}</strong>
                </div>
                <div>Tu método de acceso es:</div>
                <strong>{getTipoDeIngreso()}</strong>

                {esPerfilSocial ? (
                    <div>
                        Para acceder, tenés que seleccionar la opción 'Iniciar
                        sesión con {getTipoDeIngreso()}'.
                    </div>
                ) : (
                    <div>
                        Para acceder, tenés que ingresar tu email y contraseña.
                    </div>
                )}

                <div>¿Reconocés este email? </div>
            </section>

            <div className="container-button-dni">
                <button
                    className="ln-button --primary button-dni"
                    onClick={() =>
                        Url.RedirectToLoginDni(callback, history)
                    }
                >
                    {'Sí, ir a iniciar sesión'}
                </button>
                <button
                    className="ln-button --secondary button-dni"
                    onClick={() => comeBack()}
                >
                    {'No, volver atrás'}
                </button>
            </div>
            <TermsLogin />
        </div>
    );
};
